module.exports = __webpack_public_path__ + "img/list2.2de80109.png";